// Lib
import React, { ReactElement } from 'react';

// Utils
import { stopDefaultAndPropagation, stopPropagationOnly } from '../../../utils/domUtil';

// Components
import LinkButton from '../../buttons/LinkButton';
import DefaultErrorFurtherDetails from './DefaultErrorFurtherDetails';
import { useTranslator } from '../../i18n/useTranslator';

// Styles
import './GrammarlyErrorRenderer.scss';

interface GrammarlyErrorRendererProps {
    error: Error;
    dispatchRefreshPageAndClearLocalCache: (e: Event) => void;
    furtherDetails: string;
    dispatchToggleIntercom: () => void;
}

const GrammarlyErrorRenderer = (props: GrammarlyErrorRendererProps): ReactElement => {
    const { dispatchRefreshPageAndClearLocalCache } = props;
    const translate = useTranslator('modal', 'error.grammarly');

    return (
        <div
            className="ErrorRenderer ElementErrorRenderer GrammarlyErrorRenderer"
            onClick={stopPropagationOnly}
            onDoubleClick={stopDefaultAndPropagation}
        >
            <div className="error-message">
                <h3>{translate('title')}</h3>
                <div className="refresh-message">
                    <p>{translate('knownIssue')}</p>
                    <p>
                        {translate('disableExtension', undefined, {
                            components: {
                                refresh: <LinkButton onClick={dispatchRefreshPageAndClearLocalCache} />,
                            },
                        })}
                    </p>
                </div>
            </div>
            <DefaultErrorFurtherDetails {...props} />
        </div>
    );
};

export default GrammarlyErrorRenderer;
